import {getCasereasonConfig, onlineGetTemplateByUserId, queryCodeList, queryMdFirstAccountList} from '@/assets/js/api';

export default {
  state: {
    // 受理结果
    codeType_acceptResult: [
      {
        name: '受理',
        code: '1'
      },
      {
        name: '不予受理',
        code: '0'
      }
    ],
    defaultTemplate: [],
    codeType_1005: [],
    codeType_1018: [],
    // 分案模式
    codeType_1019: [],
    // 角色
    codeType_1020: [],
    // 短信接收方
    codeType_1021: [],
    // 站内信类型
    codeType_1026: [],
    // 站内信发布状态
    codeType_1027: [],
    // 分案状态
    codeType_8000: [
      {
        name: '待审核',
        code: '50'
      },
      {
        name: '待分案',
        code: '1'
      },
      {
        name: '审核不通过',
        code: '60'
      },
      {
        name: '已分案',
        code: '3'
      }
    ],
    // 方案类型
    codeType_8010: [],
    // 分期期数设置
    codeType_8011: [],
    // 还款日期设置
    codeType_8012: [],
    // 业务类型
    codeType_8018: [],
    // 纠纷类型
    codeType_8019: [],
    // 文书类型
    codeType_8021: [],
    // 案件分类
    codeType_8025: [],
    // 司法确认登记中的结案方式
    codeType_8026: [],
    // 驳回申请事由
    codeType_8027: [],
    // 诉讼类型
    codeType_8028: [],
    // 诉讼登记中的结案方式
    codeType_8029: [],
    // 文书签收 - 状态
    codeType_8031: [],
    // 流程状态
    codeType_8033: [],
    codeType_8035: [],
    // 送达状态
    codeType_8040: [],
    // 签字方式
    codeType_8042: [],
    // 调解成功方式
    codeType_8043: [],
    // 后续处理
    codeType_8044: [],
    // 失败原因
    codeType_8045: [],
    // 履约情况
    codeType_8046: [],
    codeType_8047: [],
    // 性别
    codeType_11400000: [],
    codeType_YZW11400000: [],
    // 证件类型
    codeType_11400022: [],
    // 证照类型
    codeType_11400032: [],
    codeType_7011: [],
    codeType_YZW11400022: [],
    codeType_11401164: [],
    // 单位类型
    codeType_11401198: [],
    codeType_11401845: [],
    codeType_38102: [],
    // 职业
    codeType_11401866: [],
    // 当事人类型
    codeType_11150171: [],
    codeType_11150173: [],
    codeType_11800011: [],
    codeType_11800027: [],
    codeType_11101033: [],
    codeType_GB0006: [],
    codeType_is: [
      {
        name: '是',
        code: '1'
      },
      {
        name: '否',
        code: '2'
      }
    ],
    firstAccountList: []
  },
  mutations: {
    SET_CODE_TYPE: (state, _data) => {
      Object.keys(_data)
        .forEach(key => {
          state[`codeType_${key}`] = _data[key];
        });
    },
    SET_CODE_CASE_REASON: (state, _data) => {
      state.codeType_8018 = [
        ..._data,
        {
          caseReasonName: '申请司法确认调解协议',
          code: '9911',
          color: 'color-3',
          name: '申请司法确认调解协议',
          pId: '8018',
          shortName: '申请司法确认调解协议',
        }
      ];
    },
    GET_TEMPLATE_BY_USERID: (state, _data) => {
      state.defaultTemplate = _data.data.defaultTemplate;
    },
    SET_FIRST_ACCOUNT_LIST: (state, _data) => {
      state.firstAccountList = _data.map(item => ({
        code: item.actId,
        name: item.actUnit
      }));
    },
  },
  actions: {
    // 获取单值代码
    async GetCodeType({commit}, code) {
      const codeTypes = [];
      if (typeof code === 'object') {
        code.forEach(item => {
          const codeType = this.state.codeType[`codeType_${item}`];
          if (!(codeType && codeType.length > 0)) {
            codeTypes.push(item);
          }
        });
      } else {
        codeTypes.push(code);
      }
      if (codeTypes.length > 0) {
        await queryCodeList(codeTypes)
          .then(({data}) => {
            commit('SET_CODE_TYPE', data);
          });
      }
      await getCasereasonConfig()
        .then(({data}) => {
          commit('SET_CODE_CASE_REASON', data);
        });
    },
    // 获取默认模板
    GetTemplateByUserId({commit}, data) {
      onlineGetTemplateByUserId(data)
        .then((response) => commit('GET_TEMPLATE_BY_USERID', response));
    },

    /**
     * 批量获取单值代码
     * @param {Object} commit commit对象
     * @param {Array} codeList 单值代码列表
     * @constructor
     */
    GetCodeListType({commit}, codeList) {
      // 获取当前list
      const _codeList = Array.isArray(codeList) ? codeList : [codeList];
      const paramsCode = [];
      _codeList.forEach(code => {
        if (this.state.codeType[`codeType_${code}`].length === 0) {
          paramsCode.push(code);
        }
      });
      queryCodeList(paramsCode)
        .then(({data}) => {
          commit('SET_CODE_TYPE', data);
        });
    }
  }
};
